import { render, staticRenderFns } from "./InboundPre.vue?vue&type=template&id=4f3c9300&scoped=true&"
import script from "./InboundPre.vue?vue&type=script&lang=js&"
export * from "./InboundPre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3c9300",
  null
  
)

export default component.exports